import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import leafImage from '../../assets/images/svg/leaf-fine-image-background.svg';
import shieldIcon from '../../assets/images/svg/background-icon.svg';
import './privacy-policy.scss';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {    // Force scroll to top when this component mounts
    useEffect(() => {
        // Use multiple aggressive scroll attempts to ensure it works
        window.scrollTo(0, 0);
        
        // Set up multiple scroll attempts with increasing delays
        const timeoutIds = [
            setTimeout(() => window.scrollTo(0, 0), 0),
            setTimeout(() => window.scrollTo(0, 0), 50),
            setTimeout(() => window.scrollTo(0, 0), 150),
            setTimeout(() => window.scrollTo(0, 0), 300),
            setTimeout(() => window.scrollTo(0, 0), 500)
        ];
        
        return () => timeoutIds.forEach(id => clearTimeout(id));
    }, []);
    
    return (
        <>
        <Helmet>
            <title>Privacy Policy | Watchelm</title>
            <meta name="description" content="Learn about our privacy practices and how we protect your personal information." />
        </Helmet>
        <div className="policy-layout">

        
            <div className="policy-content">
                <div className="main-content privacy-policy">
                    <div className="policy-section">
                        <h4>Introduction</h4>
                        <p>
                            Watchelm ("we", "our", "us") is committed to protecting and respecting your privacy. 
                            This Privacy Policy explains how we collect, use, and protect your personal information 
                            when you use our website and services.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h4>Information We Collect</h4>
                        <p>
                            We may collect the following information:
                        </p>
                        <ul>
                            <li>Name and contact information including email address</li>
                            <li>Demographic information such as postcode, preferences, and interests</li>
                            <li>Other information relevant to customer surveys and/or offers</li>
                            <li>Information about your use of our website</li>
                        </ul>
                      
                    </div>

                    <div className="policy-section">
                        <h4>How We Use Your Information</h4>
                        <p>
                            We use this information to:
                        </p>
                        <ul>
                            <li>Provide and improve our services</li>
                            <li>Communicate with you about our services</li>
                            <li>Personalize your experience on our website</li>
                            <li>Send you promotional emails about new products, special offers, or other information we think you may find interesting</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h4>Data Security</h4>
                        <p>
                            We are committed to ensuring that your information is secure. We have implemented 
                            suitable physical, electronic, and managerial procedures to safeguard and secure 
                            the information we collect online.
                        </p>
                      
                    </div>

                    <div className="policy-section">
                        <h4>Your Rights</h4>
                        <p>
                            You have the right to:
                        </p>
                        <ul>
                            <li>Access your personal data</li>
                            <li>Correct inaccurate personal data</li>
                            <li>Request that we delete your personal data</li>
                            <li>Object to the processing of your personal data</li>
                            <li>Request restriction of processing your personal data</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h4>Contact Us</h4>
                        <p>
                            If you have any questions about this Privacy Policy, please contact us.
                        </p>
                       
                    </div>
                </div>
                
            </div>
        </div>
        </>
    );
}

export default PrivacyPolicy;
